import {ApiError, errorUtils} from "../../../../utils/api/errorUtils";
import {validationErrorsUtils} from "../../../../utils/business/validationErrorsUtils";
import {ValidateErrorMap} from "../edit/UserAccountEdit";
import {Options} from "../../../../constants/options/option";
import {arrayUtils} from "../../../../utils/common/arrayUtils";
import {Entity, PerimeterUpdate} from "../../../../interfaces/perimeter/perimeter";

function manageOnSubmitErrors(e: ApiError | Promise<ApiError>, setter: (errors: ValidateErrorMap) => void) {

    if (errorUtils.interceptError(e, "EMAIL_ALR_USED")) {
        errorUtils.handleErrors(e, (apiError) => setter(validationErrorsUtils.cleanAndUpdate(apiError.errors)))
    } else {
        errorUtils.handleBackErrors(e);
        errorUtils.handleErrors(e, (apiError) => setter(validationErrorsUtils.cleanAndUpdate(apiError.errors)))
    }
}

function isOptionEmpty(_option: Options) {
    return _option && _option.id !== ""
}

function isQueryEmptyAndInitialAuthorizedAccountNotEmpty(queryAccount: string, allAuthorizedAccounts : Array<Entity>) {
    return !queryAccount && !arrayUtils.isEmpty(allAuthorizedAccounts);
}

function getInitalOptions(initialPerimeter: PerimeterUpdate) {
    return !!initialPerimeter.account.id ? [initialPerimeter.account] : []
}

export const userAccountUtils = {
    manageOnSubmitErrors,
    isOptionEmpty,
    isQueryEmptyAndInitialAuthorizedAccountNotEmpty,
    getInitalOptions
}
